export default {
  'validate-min': '不得少於{length}位',
  'validate-max': '不得多於{length}位',
  'validate-required': '此項目為必填',
  'validate-email': 'email格式不符',
  'validate-no-space': '密碼不可為空格',
  'validate-str-confirmed': '與新密碼不符',
  'find no email.': '找不到此Email',
  'password not correct.': '密碼錯誤',
  'internet error.': '網路連線錯誤',
  'email has been token.': '此後台管理員帳號/Email，請更換後再送出',
  'address is not exist.': '請輸入正確工廠地址並點擊[驗證]按鈕，直到出現驗證成功字樣，再送出',
  'duplicateVersion': '拷貝'
};
